import { render, staticRenderFns } from "./BarcodeMaintenanceDialog.vue?vue&type=template&id=2c97130c&scoped=true"
import script from "./BarcodeMaintenanceDialog.vue?vue&type=script&lang=js"
export * from "./BarcodeMaintenanceDialog.vue?vue&type=script&lang=js"
import style0 from "./BarcodeMaintenanceDialog.vue?vue&type=style&index=0&id=2c97130c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c97130c",
  null
  
)

export default component.exports